/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostProcessingPeriodMemoryForAzure extends models.BaseCostProcessingPeriodMemory {
    getFixupPrototypeFunction() { return CostProcessingPeriodMemoryForAzure.fixupPrototype; }

    static newInstance(model: Partial<CostProcessingPeriodMemoryForAzure>): CostProcessingPeriodMemoryForAzure {
        let obj = Object.assign(new CostProcessingPeriodMemoryForAzure(), model);
        CostProcessingPeriodMemoryForAzure.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostProcessingPeriodMemoryForAzure>): CostProcessingPeriodMemoryForAzure {
        if (!model) return null;
        return CostProcessingPeriodMemoryForAzure.newInstance(<CostProcessingPeriodMemoryForAzure> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostProcessingPeriodMemoryForAzure) {
        if (!obj) return;

        models.CostProcessingPeriodMemoryForAzure.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostProcessingPeriodMemoryForAzure): boolean {
        if (models.BaseCostProcessingPeriodMemory.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CostProcessingPeriodMemoryForAzure.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (typeof this.oldest_line_item_without_invoice === "string") {
            this.oldest_line_item_without_invoice = new Date(<string><any>this.oldest_line_item_without_invoice);
        }
        if (typeof this.newest_line_item_with_invoice === "string") {
            this.newest_line_item_with_invoice = new Date(<string><any>this.newest_line_item_with_invoice);
        }
    }

    /**
     * Timestamp of oldest entry without an invoice
     */
    oldest_line_item_without_invoice: Date;

    /**
     * Timestamp of newest entry with an invoice
     */
    newest_line_item_with_invoice: Date;

}
